"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* this reducer is different. Instead of listening in on actions we want to evaluate the total
 * global state every time. This is only useful in marginal cases and should be used sparingly
 * since it'll be run after EVERY CHANGE.
 */






var _unread = require('shared/services/unread');













// The JS declared `state = { inboxHasAlert: false }` but never read it: the
// result is recomputed from globalState on every action.
 function inducedValuesReducer (
  _state,
  _action,
  globalState,
) {
  /* try to separate every induced value into a function */

  function doesInboxHaveAlert () {
    const { currentUser, blobjects, teams } = globalState

    if (!currentUser || !blobjects || !teams) {
      return false
    }

    /* we pre-calculate for each team whether it's inboxable */
    const teamToCurrentUserInboxable = Object.keys(currentUser.Teams || {}).reduce((acc, tk) => {
      const team = currentUser.Teams[tk ]
      acc[tk] = team && team.Inboxable
      return acc
    }, {})

    for (const bkey in blobjects) {
      const blobject = blobjects[bkey ]
      if (!blobject) {
        continue
      }

      // Only the current user's entry carries Completed.
      const currentUserMetadata = blobject.UserMetadata[currentUser.UserKey] 

      if (!_unread.isUnreadForMe.call(void 0, blobject, currentUser.UserKey)) {
        continue
      }

      if (currentUserMetadata && currentUserMetadata.Completed) {
        continue
      }

      /* finally check inboxability */
      if (blobject.UserSubscribers && blobject.UserSubscribers[currentUser.UserKey]) {
        /* NOTE: there might be more stuff here? idk? */
        return true
      } else {
        /* does one of our inboxable teams subscribe? */
        for (const teamSubscriberKey in blobject.TeamSubscribers) {
          /* we have an inboxable team */
          if (teamToCurrentUserInboxable[teamSubscriberKey]) {
            return true
          }
        }
      }
    }

    return false
  }

  return {
    inboxHasAlert: doesInboxHaveAlert(),
  }
} exports.default = inducedValuesReducer;
